import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowDown, ArrowUpRight, Check, Instagram, Menu, X } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/wyeeJtwvu1HiXsJKfGXny6/1.png';
const ICE_IMAGE = 'https://cdn.magicpatterns.com/uploads/knKE32EsZkYsqPa1ui7YrB/DSC03885.jpg';
const SOCIAL_IMAGE = 'https://cdn.magicpatterns.com/uploads/m4VHGC1GgxgtGcoFZGpH81/IMG_0693.jpg';
const CAN_IMAGE = 'https://cdn.magicpatterns.com/uploads/wDu3fKhK1RBeGFe1tY72ry/DSC03888.jpg';
const VIDEO_MOMENT = 'https://cdn.magicpatterns.com/uploads/macVvEoEwdpGBSYDC8PDiv/CPSTHLM_30.mp4';
const PEOPLE_IMAGE_1 = 'https://cdn.magicpatterns.com/uploads/1KzvTsy3KfZ88WPDkaVLMn/WAGHORN_2026-03-22_18.jpg';
const PEOPLE_IMAGE_2 = 'https://cdn.magicpatterns.com/uploads/oLZUyGYJTdHH83PscaSwsS/IMG_0700.jpg';
const ICE_BOWL_IMAGE = 'https://cdn.magicpatterns.com/uploads/p4Sk3dNMD8P9BQwDabDdK8/DSC04025.jpg';
const CLOSING_IMAGE = 'https://cdn.magicpatterns.com/uploads/mUGwrPwqeYegR1sEkvQE7m/IMG_0669_4.png';
const CROWD_IMAGE = 'https://cdn.magicpatterns.com/uploads/q1QGnD1Kd2T9Us82VxWgCC/2025-11-09_-67.jpg';
const SILVER_HEART = 'https://cdn.magicpatterns.com/uploads/rJT9byhsXeU9KaTKr1LjUf/1.png';
const BEET_RED = 'https://cdn.magicpatterns.com/uploads/qULQc3HvRqojPLg7YXAYH5/Rodbeta.png';
const BEET_YELLOW = 'https://cdn.magicpatterns.com/uploads/3uGPvVV79oZz5PUQ2CQhbW/gulbeta.png';
const BEET_WHITE = 'https://cdn.magicpatterns.com/uploads/4xdunyqX2XsEhDvajcVBUY/VITBETA.png';
const CAN_LINEUP_IMAGE = 'https://cdn.magicpatterns.com/uploads/4nRxNXZRgXs6U5T42kX5ab/Burk_1.png';
const INSTAGRAM_URL = 'https://www.instagram.com/beatyourbest_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
const CONTACT_EMAIL = 'info@beatsoda.com';
const WEB3FORMS_KEY = 'a23b9419-6869-4092-bd1e-0a48a2461c5e';
const EASE = [0.23, 1, 0.32, 1] as const;
const rise = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: EASE
    }
  }
};
const stagger = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05
    }
  }
};
const WORLD_WORDS = ['Music', 'Food', 'Friends', 'Travel', 'Sport', 'Nightlife'];
const NAV_LINKS = [{
  label: 'The Drink',
  id: 'product'
}, {
  label: 'Flavours',
  id: 'flavours'
}, {
  label: 'World',
  id: 'world'
}, {
  label: 'People',
  id: 'people'
}, {
  label: 'Story',
  id: 'story'
}, {
  label: 'Join',
  id: 'join'
}];
const COMING_SOON = [{
  name: 'Yellow BEAT',
  symbol: BEET_YELLOW
}, {
  name: 'White BEAT',
  symbol: BEET_WHITE
}];
const INGREDIENTS = ['Beetroot', 'Grapefruit', 'Pomegranate', 'Lemon', 'Elderflower', 'Apple Juice Concentrate', 'Apple Cider Vinegar'];
export function LandingPage() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full bg-beat-black font-sans text-white antialiased" data-id="element-1" data-mp="2bxmopnyha3zi">
      <SiteHeader onNavigate={scrollTo} data-id="element-2" data-mp="2bva6d9ot5rlx" />

      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="relative min-h-screen w-full overflow-hidden" data-id="element-3" data-mp="2ln694y1ua5wh">
        <motion.img src={ICE_IMAGE} alt="A cold BEAT can buried in crushed ice" initial={{
        opacity: 0,
        scale: 1.06
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: EASE
      }} className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-4" data-mp="2lp0sw91djryz" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to top, rgba(10,10,10,0.88) 0%, rgba(10,10,10,0.45) 45%, rgba(10,10,10,0.12) 75%, rgba(255,255,255,0.35) 100%)'
      }} data-id="element-5" data-mp="21yfcx57e6hei" />

        <motion.div initial="hidden" animate="visible" variants={stagger} className="relative z-10 flex min-h-screen flex-col justify-end px-5 pb-20 pt-40 md:px-10 md:pb-24" data-id="element-6" data-mp="3devhu4lblfn4">
          <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-white/70 uppercase" data-id="element-7" data-mp="3gvrntg2jxsik">
            REAL ROOT · REAL FRUIT · REAL FLAVOUR
          </motion.p>

          <motion.h1 variants={rise} className="max-w-[18ch] text-5xl font-medium leading-[1.1] tracking-tight md:text-7xl lg:text-8xl" style={{
          fontSize: "96px"
        }} data-id="element-8" data-mp="3bz9juif1py7a">
            A real way to experience  <span className="text-beat-red" data-id="element-9" data-mp="3p83hsfg0m8x">life.</span>
          </motion.h1>

          <motion.div variants={rise} className="mt-10 flex flex-col gap-6 sm:flex-row sm:items-center" data-id="element-10" data-mp="3n52yegnzapy">
            <button onClick={() => scrollTo('product')} className="group inline-flex items-center gap-3 rounded-full bg-beat-red px-8 py-4 text-base font-medium text-white transition-colors duration-150 hover:bg-white hover:text-beat-black" style={{
            transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)'
          }} data-id="element-11" data-mp="3utycc5lm2g5k">
              Discover BEAT
              <ArrowUpRight size={18} className="transition-transform duration-150 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-12" data-mp="hi7k5xqyomi2" />
            </button>
            <p className="max-w-xs text-base text-white/60" data-id="element-13" data-mp="162avtn03t2ay">
              A Real Root & Fruit Soda 
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.6,
        duration: 0.6
      }} className="absolute bottom-8 right-5 z-10 text-white/50 md:right-10" data-id="element-14" data-mp="s42pioh6gon4">
          <ArrowDown size={22} className="animate-bounce" data-id="element-15" data-mp="n2n8r8m194aj" />
        </motion.div>
      </section>

      {/* ── 02: THIS IS BEAT (PRODUCT) ───────────────────────── */}
      <section id="product" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-16" data-mp="8bxtnv5gb51e">
        <div className="mx-auto grid max-w-[1200px] items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-17" data-mp="ddddjjvw75i7">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} data-id="element-18" data-mp="3vji9oij9selz">
            <motion.p variants={rise} className="mb-8 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-19" data-mp="2624ntc59oufh">
              The Drink
            </motion.p>
            <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-20" data-mp="2191p6plmuusf">
              This is BEAT.
            </motion.h2>
            <motion.p variants={rise} className="mt-8 max-w-md text-xl leading-relaxed text-white/70" data-id="element-21" data-mp="1sb7vznj60h9h">
              A drink for the moments worth remembering. Bright, bold, rewarding, and balanced.
            </motion.p>

            <motion.button variants={rise} onClick={() => scrollTo('flavours')} className="mt-10 inline-flex items-center gap-2 text-base font-medium text-beat-red transition-colors hover:text-white" data-id="element-22" data-mp="2k1vu0qpjl6ix">
              Discover the flavours <ArrowDown size={18} data-id="element-23" data-mp="2b30nfdil5uf3" />
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.8,
          ease: EASE
        }} className="relative aspect-[4/5] w-full overflow-hidden rounded-3xl" data-id="element-24" data-mp="14iiypefu17vt">
            <img src={CAN_IMAGE} alt="A BEAT can resting on a railing" className="h-full w-full object-cover" data-id="element-25" data-mp="3k9asfiw4xgdm" />
          </motion.div>
        </div>
      </section>

      {/* ── 02B: THE FLAVOURS ────────────────────────────────── */}
      <section id="flavours" className="scroll-mt-20 rounded-t-[3rem] bg-[#F5F3EF] px-5 py-20 text-beat-black md:px-10 md:py-28" data-id="element-26" data-mp="3tz41ac4w7he6">
        <div className="mx-auto max-w-[1200px]" data-id="element-27" data-mp="7s5qzbtvk7up">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-10 md:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] md:items-end" data-id="element-28" data-mp="7tgurbnblflt">
            <div data-id="element-29" data-mp="29lvca9lyci1p">
              <motion.p variants={rise} className="mb-6 text-sm font-medium uppercase tracking-widest text-beat-red" data-id="element-30" data-mp="2dkualbd6hgk6">
                The Flavours
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium leading-[1.05] tracking-tight md:text-6xl" data-id="element-31" data-mp="1umr3n56frkdi">
                Meet BEAT.
              </motion.h2>
              <motion.div variants={rise} className="mt-8 h-px w-16 bg-beat-red" data-id="element-32" data-mp="23fvvdchqp548" />
            </div>
            <motion.p variants={rise} className="max-w-md text-xl leading-relaxed text-black/60" data-id="element-33" data-mp="1zgvfo2uk6ilg">
              Bold. Refreshing. Made from real ingredients. For real moments. We
              start with one — the red beet.
            </motion.p>
          </motion.div>

          {/* Red BEAT — available now */}
          <motion.article initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="mt-16" data-id="element-34" data-mp="1krz784olb3kb">
            <motion.div variants={rise} className="py-4 md:py-8" data-id="element-35" data-mp="2w4t70wrg43o0">
              <img src={CAN_LINEUP_IMAGE} alt="Red BEAT can shown from three sides, with beetroot artwork, ingredients and nutrition" className="mx-auto w-full max-w-4xl mix-blend-darken" data-id="element-36" data-mp="2r7036adm7lqw" />
            </motion.div>
            <motion.div variants={rise} className="grid gap-10 border-t border-black/10 pt-10 md:grid-cols-2 md:pt-14" data-id="element-37" data-mp="33pm0kroqaxk4">
              <div data-id="element-38" data-mp="2pqw2p9u34tup">
                <div className="flex items-center gap-3" data-id="element-39" data-mp="2prfa3wm3zzuh">
                  <span className="h-3 w-3 rounded-full bg-beat-red" data-id="element-40" data-mp="2unw0kxgs6qaq" />
                  <span className="text-sm font-medium uppercase tracking-widest text-beat-red" data-id="element-41" data-mp="3ie9w4xykr7a2">
                    Available now
                  </span>
                </div>
                <div className="mt-5 flex items-center gap-5" data-id="element-42" data-mp="3nffkykp46aeb">
                  <img src={BEET_RED} alt="" aria-hidden="true" className="h-24 w-auto flex-shrink-0 mix-blend-darken md:h-32" data-id="element-43" data-mp="38nnj9bi8suv2" />
                  <h3 className="text-3xl font-medium tracking-tight md:text-5xl" data-id="element-44" data-mp="3dlgnw03wdgt8">
                    Red BEAT
                  </h3>
                </div>
                <p className="mt-5 max-w-md text-lg leading-relaxed text-black/60" data-id="element-45" data-mp="9yq6sa10y90a">
                  Beetroot meets grapefruit, pomegranate and citrus in a vibrant
                  blend with floral notes and a crisp finish.
                </p>
              </div>
              <div className="flex flex-col justify-center gap-6 md:border-l md:border-black/10 md:pl-14" data-id="element-46" data-mp="242ttb7hnwum3">
                <div className="flex flex-wrap gap-x-6 gap-y-3 text-base text-black/70" data-id="element-47" data-mp="291ociajjkl6q">
                  {INGREDIENTS.map(item => <span key={item} data-id="element-48" data-mp="1ucs5mgt81e7p">{item}</span>)}
                </div>
                <p className="border-t border-black/10 pt-6 text-base text-black/50" data-id="element-49" data-mp="1z3qn3jpy4icj">
                  250 ml · No added sugar · Low calorie · Caffeine free ·
                  Alcohol free
                </p>
              </div>
            </motion.div>
          </motion.article>

          {/* Yellow + White — coming soon */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="mt-6 grid gap-6 md:grid-cols-2 md:gap-8" data-id="element-50" data-mp="1bdwbt6l9z1ue">
            {COMING_SOON.map(flavour => <motion.article key={flavour.name} variants={rise} className="flex items-center gap-6 rounded-3xl border border-black/10 p-8" data-id="element-51" data-mp="wrz9gk09quge">
                <img src={flavour.symbol} alt="" aria-hidden="true" className="h-24 w-auto flex-shrink-0 opacity-60 mix-blend-darken" data-id="element-52" data-mp="16pn3t8typzy1" />
                <div data-id="element-53" data-mp="11pinbit2157t">
                  <h3 className="text-xl font-medium tracking-tight text-black/70 md:text-2xl" data-id="element-54" data-mp="11oz8wc2m4yyj">
                    {flavour.name}
                  </h3>
                  <p className="mt-1 text-base text-black/45" data-id="element-55" data-mp="1arrzse7vv8nu">Coming soon</p>
                </div>
              </motion.article>)}
          </motion.div>

          <motion.p initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={rise} className="mt-12 text-base text-black/50" data-id="element-56" data-mp="1pfcxttpwihow">
            No alcohol. No caffeine. Nothing artificial.
          </motion.p>
        </div>
      </section>

      {/* ── MARQUEE ──────────────────────────────────────────── */}
      <Marquee data-id="element-57" data-mp="21io26o0qmkuv" />

      {/* ── 03: THE WORLD ────────────────────────────────────── */}
      <section id="world" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-58" data-mp="26hij1kf59zcc">
        <div className="mx-auto max-w-[1200px]" data-id="element-59" data-mp="26fed6wxoqq9f">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] lg:gap-16" data-id="element-60" data-mp="2bgbznlpqa6gq">
            <div data-id="element-61" data-mp="2k8nmyypjpdsh">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-62" data-mp="2kb9s6royrh7j">
                The World
              </motion.p>
              <motion.p variants={rise} className="text-3xl font-medium leading-snug text-white md:text-4xl" data-id="element-63" data-mp="2u7mlvpkidv2a">
                BEAT lives where good people, good taste and good experiences
                meet.
              </motion.p>
              <motion.p variants={rise} className="mt-6 max-w-sm text-lg leading-relaxed text-white/60" data-id="element-64" data-mp="zveswhrqzo95">
                A dinner. A festival. A studio. A beach. A basement bar at 1am.
                The place changes. The feeling doesn't.
              </motion.p>
            </div>

            <motion.div variants={rise} data-id="element-65" data-mp="3d9lobrra5yk3">
              <ul className="flex flex-wrap items-baseline gap-x-6 gap-y-2" data-id="element-66" data-mp="399lc8drnlzg7">
                {WORLD_WORDS.map(word => <li key={word} className="text-4xl font-medium tracking-tight text-white/85 md:text-5xl lg:text-6xl" data-id="element-67" data-mp="34bt88ldqimvn">
                    {word}
                    <span className="text-beat-red" data-id="element-68" data-mp="4v3ky3cab76t">.</span>
                  </li>)}
              </ul>
              <p className="mt-10 text-2xl font-medium text-beat-red md:text-3xl" data-id="element-69" data-mp="s6zm4vd0wz6">
                Something is happening.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ── MOMENT: THE FLOOR ────────────────────────────────── */}
      <Moment src={CROWD_IMAGE} alt="A packed room dancing in front of a DJ booth" label="Stockholm · Saturday" data-id="element-70" data-mp="2gn0jp9zfzhb2" />

      {/* ── 04: PEOPLE WITH A BEAT ───────────────────────────── */}
      <section id="people" className="scroll-mt-20 rounded-t-[3rem] bg-white px-5 py-20 text-beat-black md:px-10 md:py-28" data-id="element-71" data-mp="3cuypxy6rffq">
        <div className="mx-auto max-w-[1200px]" data-id="element-72" data-mp="85o6kuoyb3w1">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-73" data-mp="3qj5fhstf1as3">
            <div data-id="element-74" data-mp="n1ds6rq85f08">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-75" data-mp="n2yoomw3n80q">
                People with a beat
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-76" data-mp="d4958pok1fid">
                BEAT belongs to people with their own taste.
              </motion.h2>

              <motion.div variants={stagger} className="mt-10 grid gap-8 border-t border-black/10 pt-10" data-id="element-77" data-mp="2xt5l4nwjjg3h">
                <PeopleItem title="Create" copy="Ideas that land. Nights that stay sharp all the way to the end." data-id="element-78" data-mp="32t1p4n58n7j1" />
                <PeopleItem title="Connect" copy="Conversations you actually remember. Presence you can feel." data-id="element-79" data-mp="2v87gws3dx3qb" />
                <PeopleItem title="Move" copy="A body that shows up the next morning, ready to go again." data-id="element-80" data-mp="2q9nvqtwm7vz0" />
              </motion.div>
            </div>

            <motion.div variants={rise} className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-81" data-mp="2zb3wsb1jilqk">
              <div className="mt-12 md:mt-24" data-id="element-82" data-mp="2bl9kpvp1p17d">
                <img src={PEOPLE_IMAGE_1} alt="Candid shot of a woman drinking BEAT at a party" className="aspect-[3/4] w-full object-cover rounded-3xl" data-id="element-83" data-mp="2bm2uz6n7q8u9" />
              </div>
              <div data-id="element-84" data-mp="2lbmgkk2b8gst">
                <img src={PEOPLE_IMAGE_2} alt="Candid shot of a man drinking BEAT with sunglasses" className="aspect-[3/4] w-full object-cover rounded-3xl" data-id="element-85" data-mp="2lc4gbqo6ld5h" />
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ── 05: THE WORLD IN MOTION ──────────────────────────── */}
      <Moment src={VIDEO_MOMENT} alt="Bartender grabbing a BEAT can from an ice bowl" label="Club · 23:45" isVideo data-id="element-86" data-mp="1nvf7ve4q7cn4" />

      {/* ── 06: THE STORY ────────────────────────────────────── */}
      <section id="story" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-87" data-mp="3svgm8v9hstr5">
        <div className="mx-auto max-w-[1200px]" data-id="element-88" data-mp="1jew70f48l8z">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-89" data-mp="1kq1j4o7m127">
            <div data-id="element-90" data-mp="351f98tzj3gtg">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-91" data-mp="39xx85d86gkxv">
                The Story
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-92" data-mp="3ezcx3gdh7blj">
                São Paulo &rarr; Stockholm &rarr; BEAT.
              </motion.h2>
            </div>
            <div className="flex flex-col justify-center" data-id="element-93" data-mp="u942ntalhdhz">
              <motion.p variants={rise} className="text-xl leading-relaxed text-white/70 md:text-2xl" data-id="element-94" data-mp="y7bgaf9rhyoy">
                Someone tasted something amazing. They couldn't stop thinking about it. They brought the idea home. They met the right people. BEAT happened.
              </motion.p>
              <motion.p variants={rise} className="mt-6 text-xl leading-relaxed text-white/70 md:text-2xl" data-id="element-95" data-mp="29xk0ke0u6gih">
                The moment matters more than the beet.
              </motion.p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── 07: CLOSING ──────────────────────────────────────── */}
      <section className="relative overflow-hidden bg-beat-red px-5 py-24 md:px-10 md:py-32" data-id="element-96" data-mp="1uzjaw1qjx0ws">
        <img src={CLOSING_IMAGE} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-97" data-mp="1r011a246kc99" />
        <div className="absolute inset-0" style={{
        backgroundColor: '#C8102E',
        mixBlendMode: 'multiply',
        opacity: 0.55
      }} data-id="element-98" data-mp="1m2916ktdtjtz" />
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={stagger} className="relative z-10 mx-auto flex max-w-[1200px] flex-col items-center text-center" data-id="element-99" data-mp="3ge5t0evqkrpk">
          <motion.h2 variants={rise} className="text-[13vw] font-medium leading-[1.05] tracking-tight sm:text-6xl md:text-7xl lg:text-[80px]" data-id="element-100" data-mp="2u74orymqkszn">
            Don't waste
            <br data-id="element-101" data-mp="2ki3big7ksppd" />
            a heartbeat.
          </motion.h2>
        </motion.div>

        <div className="relative mx-auto mt-8 w-[68vw] max-w-[420px]" data-id="element-102" data-mp="2kg0c55kj9k7z">
          <div aria-hidden="true" className="absolute inset-[-12%] rounded-full" style={{
          background: 'radial-gradient(circle, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 68%)'
        }} data-id="element-103" data-mp="26hadvmlz9ei1" />
          <img src={SILVER_HEART} alt="" aria-hidden="true" className="relative h-auto w-full" style={{
          mixBlendMode: 'multiply'
        }} data-id="element-104" data-mp="1wm8nknfyu6dv" />
        </div>
      </section>

      {/* ── 08: JOIN ─────────────────────────────────────────── */}
      <section id="join" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-105" data-mp="3vy1p8xdp7zwx">
        <div className="mx-auto max-w-[1200px]" data-id="element-106" data-mp="1ka6dqij0xlij">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="mb-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-107" data-mp="1kay4ng1oev2h">
            <div data-id="element-108" data-mp="1u1swczxoymvb">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-109" data-mp="1p9j6tl0hnotk">
                Join
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-110" data-mp="232r0rjc1kwef">
                Join the BEAT.
              </motion.h2>
            </div>
            <motion.a variants={rise} href={`mailto:${CONTACT_EMAIL}`} className="text-2xl font-medium text-white underline decoration-beat-red decoration-2 underline-offset-8 transition-colors duration-150 hover:text-beat-red md:text-4xl" data-id="element-111" data-mp="2cxj0ott3jvcd">
              {CONTACT_EMAIL}
            </motion.a>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="grid gap-6 lg:grid-cols-3" data-id="element-112" data-mp="dnkhlrj5xhu8">
            <motion.a variants={rise} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="group flex flex-col justify-between rounded-3xl bg-white/5 p-8 transition-colors duration-150 hover:bg-beat-red" data-id="element-113" data-mp="21rfbhdsj7avf">
              <Instagram size={26} className="mb-12 text-beat-red transition-colors duration-150 group-hover:text-white" data-id="element-114" data-mp="2bk4bncimt2bg" />
              <div data-id="element-115" data-mp="1itckwukc55vi">
                <h3 className="text-2xl font-medium" data-id="element-116" data-mp="1iu5t7zyy03fr">
                  Follow
                </h3>
                <p className="mt-2 flex items-center gap-2 text-base text-white/60 transition-colors duration-150 group-hover:text-white/90" data-id="element-117" data-mp="1xremx0bpxjan">
                  @beatyourbest_
                  <ArrowUpRight size={18} data-id="element-118" data-mp="395a5yk5quc75" />
                </p>
              </div>
            </motion.a>

            <NotifyForm data-id="element-119" data-mp="346yuk4zsvtmt" />
            <StockForm data-id="element-120" data-mp="345nofyivu9sj" />
          </motion.div>
        </div>
      </section>

      {/* ── FOOTER ───────────────────────────────────────────── */}
      <footer className="px-5 py-12 md:px-10" data-id="element-121" data-mp="3bsaz0wobgbng">
        <div className="mx-auto flex max-w-[1200px] flex-col gap-8 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between" data-id="element-122" data-mp="3gq2we67qcpz1">
          <BeatMark className="w-28" data-id="element-123" data-mp="32rmoiby4stfb" />
          <div className="flex flex-col gap-4 text-sm text-white/50 md:flex-row md:items-center md:gap-8" data-id="element-124" data-mp="36q3ma4vnwrk2">
            <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-150 hover:text-white" data-id="element-125" data-mp="3uhhemattcn51">
              {CONTACT_EMAIL}
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="transition-colors duration-150 hover:text-white" data-id="element-126" data-mp="3lo4byh5y675r">
              Instagram
            </a>
            <p data-id="element-127" data-mp="3pnmvp9m18c70">© {new Date().getFullYear()} BEAT Soda</p>
          </div>
        </div>
      </footer>
    </div>;
}
function SiteHeader({
  onNavigate
}: {
  onNavigate: (id: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  const go = (id: string) => {
    setOpen(false);
    window.setTimeout(() => onNavigate(id), 260);
  };
  return <>
      <header className={`fixed inset-x-0 top-0 z-40 transition-colors duration-200 ${scrolled && !open ? 'bg-beat-black/85 backdrop-blur' : 'bg-transparent'}`} style={{
      transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)'
    }} data-id="element-128" data-mp="857jdundgbpl">
        <div className="flex w-full items-center justify-between px-4 py-3 md:px-8 md:py-4" style={{
        paddingBottom: "0px",
        paddingLeft: "20px",
        width: "853px",
        height: "82px"
      }} data-id="element-129" data-mp="3qcx31yync3hq">
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} aria-label="BEAT Soda — back to top" className="-ml-5 md:-ml-7" data-id="element-130" data-mp="3b8u8erpowy30">
            <BeatMark className="w-40 md:w-52" data-id="element-131" data-mp="3l7jtetcvuynh" />
          </button>

          <div className="flex items-center gap-3" style={{
          paddingBottom: "14px"
        }} data-id="element-132" data-mp="3q6wcd30mvlks">
            <button onClick={() => go('join')} className="hidden rounded-full bg-beat-red px-6 py-2.5 text-sm font-medium text-white transition-colors duration-150 hover:bg-white hover:text-beat-black sm:inline-flex" data-id="element-133" data-mp="2sj5pxy30za4j">
              Join the BEAT
            </button>
            <button onClick={() => setOpen(true)} aria-label="Open menu" aria-expanded={open} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 hover:border-white hover:bg-white hover:text-beat-black" data-id="element-134" data-mp="32g0qemiuzklg">
              <Menu size={20} data-id="element-135" data-mp="2epwmsf5o7kug" />
            </button>
          </div>
        </div>
      </header>

      <AnimatePresence data-id="element-136" data-mp="kc28419iwy4j">
        {open && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: EASE
      }} className="fixed inset-0 z-50 bg-beat-black" data-id="element-137" data-mp="fcfxlzl2xvzf">
            <div className="flex h-full w-full flex-col px-5 py-4 md:px-10 md:py-5" data-id="element-138" data-mp="p9u16ylwmqab">
              <div className="flex items-center justify-between" data-id="element-139" data-mp="1318wo4x00jy9">
                <BeatMark className="-ml-5 w-40 md:-ml-7 md:w-52" data-id="element-140" data-mp="z0f7z9bqf14b" />
                <button onClick={() => setOpen(false)} aria-label="Close menu" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 hover:border-white hover:bg-white hover:text-beat-black" data-id="element-141" data-mp="z05j5p2fb007">
                  <X size={20} data-id="element-142" data-mp="3escittyinacg" />
                </button>
              </div>

              <nav className="flex flex-1 flex-col justify-center" data-id="element-143" data-mp="39t9ph6rweskb">
                <motion.ul initial="hidden" animate="visible" variants={stagger} className="flex flex-col gap-2" data-id="element-144" data-mp="1pafnzwcucc42">
                  {NAV_LINKS.map(link => <motion.li key={link.id} variants={rise} data-id="element-145" data-mp="1u9sd6nr6pv9t">
                      <button onClick={() => go(link.id)} className="text-4xl font-medium tracking-tight text-white/80 transition-colors duration-150 hover:text-beat-red md:text-6xl" data-id="element-146" data-mp="1fkmdyzsck51x">
                        {link.label}
                      </button>
                    </motion.li>)}
                </motion.ul>
              </nav>

              <div className="flex flex-col gap-3 border-t border-white/10 py-6 text-base text-white/50 md:flex-row md:items-center md:justify-between" data-id="element-147" data-mp="1bjaulc02gg26">
                <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-150 hover:text-white" data-id="element-148" data-mp="wnuuoqct1pxv">
                  {CONTACT_EMAIL}
                </a>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-149" data-mp="2r12vqzrdixry">
                  @beatyourbest_ <ArrowUpRight size={16} data-id="element-150" data-mp="2uiqp4ys1u22l" />
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function BeatMark({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative flex items-center justify-center ${className}`} data-id="element-151" data-mp="2kjszttmsu4ij">
      <img src={LOGO_URL} alt="BEAT Soda" className="w-full h-auto object-contain" style={{
      paddingBottom: "12px"
    }} data-id="element-152" data-mp="2gj92aoybcyvv" />
    </div>;
}
function Marquee() {
  const line = 'Good taste — Good people — Good times — ';
  return <div className="overflow-hidden bg-beat-red py-5" data-id="element-153" data-mp="38b6tc2wos653">
      <motion.div animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 22,
      ease: 'linear',
      repeat: Infinity
    }} className="flex w-max whitespace-nowrap" data-id="element-154" data-mp="33hc0o9z3sgtv">
        {[0, 1].map(group => <span key={group} className="text-lg font-medium uppercase tracking-widest text-white md:text-xl" data-id="element-155" data-mp="3vzhoqqjm5dlz">
            {line.repeat(6)}
          </span>)}
      </motion.div>
    </div>;
}
function Moment({
  src,
  alt,
  label,
  isVideo = false
}: {
  src: string;
  alt: string;
  label: string;
  isVideo?: boolean;
}) {
  return <section className="relative h-[80vh] w-full overflow-hidden md:h-screen" data-id="element-156" data-mp="1ioojzrjdto2n">
      {isVideo ? <motion.video src={src} autoPlay loop muted playsInline initial={{
      opacity: 0,
      scale: 1.04
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-10%'
    }} transition={{
      duration: 1.1,
      ease: EASE
    }} className="h-full w-full object-cover" data-id="element-157" data-mp="1moozlfi7w5ba" /> : <motion.img src={src} alt={alt} initial={{
      opacity: 0,
      scale: 1.04
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-10%'
    }} transition={{
      duration: 1.1,
      ease: EASE
    }} className="h-full w-full object-cover" data-id="element-158" data-mp="21kxy2euaaemn" />}
      <p className="absolute bottom-6 left-5 text-sm font-medium tracking-widest text-white/80 uppercase md:left-10" data-id="element-159" data-mp="2kds3oi60oue7">
        {label}
      </p>
    </section>;
}
function PeopleItem({
  title,
  copy
}: {
  title: string;
  copy: string;
}) {
  return <motion.div variants={rise} data-id="element-160" data-mp="1qaqlbh7put5i">
      <h3 className="text-3xl font-medium md:text-4xl" data-id="element-161" data-mp="1qdmj95jkdhty">
        {title}
        <span className="text-beat-red" data-id="element-162" data-mp="24arm6wnze0kz">.</span>
      </h3>
      <p className="mt-4 max-w-xs text-lg leading-relaxed text-black/60" data-id="element-163" data-mp="209zew8yo65rc">
        {copy}
      </p>
    </motion.div>;
}
async function sendToBeat(payload: Record<string, string>) {
  const response = await fetch('https://api.web3forms.com/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      access_key: WEB3FORMS_KEY,
      from_name: 'BEAT Website',
      to: CONTACT_EMAIL,
      ...payload
    })
  });
  return response.ok;
}
function NotifyForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!email) return;
    setStatus('loading');
    const ok = await sendToBeat({
      subject: 'BEAT — new launch signup',
      email,
      message: `New launch signup.\n\nEmail: ${email}`
    }).catch(() => false);
    setStatus(ok ? 'success' : 'error');
    if (ok) setEmail('');
  };
  return <motion.div variants={rise} className="flex flex-col justify-between rounded-3xl bg-white/5 p-8" data-id="element-164" data-mp="9s13joj5ujja">
      <p className="mb-16 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-165" data-mp="xhn70o6kfkx3">
        Launch
      </p>
      <div data-id="element-166" data-mp="12e4262c6mzjo">
        <h3 className="text-2xl font-medium" data-id="element-167" data-mp="12dubecjbcocx">
          Be first
        </h3>
        {status === 'success' ? <p className="mt-4 flex items-center gap-2 text-base font-medium text-beat-red" data-id="element-168" data-mp="si0qa4rj3mjj">
            <Check size={18} data-id="element-169" data-mp="sjtyhohsietn" /> You're on the list
          </p> : <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-4" data-id="element-170" data-mp="3883u8ezvm46l">
            <input type="email" required value={email} onChange={event => setEmail(event.target.value)} placeholder="Your email" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-171" data-mp="3d8riiswq06x4" />
            <button type="submit" disabled={status === 'loading'} className="self-start text-base font-medium text-white transition-colors duration-150 hover:text-beat-red disabled:opacity-50" data-id="element-172" data-mp="2jt70z171ypzn">
              {status === 'loading' ? 'Sending…' : 'Notify me →'}
            </button>
            {status === 'error' && <p className="text-sm text-white/50" data-id="element-173" data-mp="1w3cqgqa7hdik">
                Didn't go through — try again.
              </p>}
          </form>}
      </div>
    </motion.div>;
}
function StockForm() {
  const [form, setForm] = useState({
    company: '',
    email: '',
    notes: ''
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!form.company || !form.email) return;
    setStatus('loading');
    const ok = await sendToBeat({
      subject: 'BEAT — new stockist enquiry',
      email: form.email,
      company: form.company,
      notes: form.notes || 'No notes',
      message: `New stockist enquiry.\n\nCompany: ${form.company}\nEmail: ${form.email}\nNotes: ${form.notes || 'No notes'}`
    }).catch(() => false);
    setStatus(ok ? 'success' : 'error');
    if (ok) setForm({
      company: '',
      email: '',
      notes: ''
    });
  };
  return <motion.div variants={rise} className="flex flex-col justify-between rounded-3xl bg-white/5 p-8" data-id="element-174" data-mp="i2q2sd308k9c">
      <p className="mb-16 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-175" data-mp="d56s1n5impm5">
        Trade
      </p>
      <div data-id="element-176" data-mp="86vd4y0d5ox2">
        <h3 className="text-2xl font-medium" data-id="element-177" data-mp="837ly5ie5eli">
          Stock BEAT
        </h3>
        {status === 'success' ? <p className="mt-4 flex items-center gap-2 text-base font-medium text-beat-red" data-id="element-178" data-mp="38bq0ua1a734">
            <Check size={18} data-id="element-179" data-mp="3vc4lkw5ypbve" /> We'll be in touch
          </p> : <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-4" data-id="element-180" data-mp="3kon15z26jmny">
            <input type="text" required value={form.company} onChange={event => setForm({
          ...form,
          company: event.target.value
        })} placeholder="Venue or company" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-181" data-mp="3pnrd2xghnyhz" />
            <input type="email" required value={form.email} onChange={event => setForm({
          ...form,
          email: event.target.value
        })} placeholder="Your email" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-182" data-mp="c8v0vos2ht5m" />
            <textarea rows={2} value={form.notes} onChange={event => setForm({
          ...form,
          notes: event.target.value
        })} placeholder="Volumes, timing, anything else" disabled={status === 'loading'} className="w-full resize-none border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-183" data-mp="vx3r3ta1vp2h" />
            <button type="submit" disabled={status === 'loading'} className="self-start text-base font-medium text-white transition-colors duration-150 hover:text-beat-red disabled:opacity-50" data-id="element-184" data-mp="1a2vywytvm3hn">
              {status === 'loading' ? 'Sending…' : 'Send enquiry →'}
            </button>
            {status === 'error' && <p className="text-sm text-white/50" data-id="element-185" data-mp="waxtaxzdipq8">
                Didn't go through — try again.
              </p>}
          </form>}
      </div>
    </motion.div>;
}